import type { Consent } from "./fetchCRMConsentStatus";

export type SharedSpaceConsentFailureReason = "missing" | "check_failed";

export class SharedSpaceConsentGateError extends Error {
  reason: SharedSpaceConsentFailureReason;

  constructor(reason: SharedSpaceConsentFailureReason) {
    super(reason);
    this.name = "SharedSpaceConsentGateError";
    this.reason = reason;
  }
}

export const isSharedSpaceConsentGateError = (
  err: unknown,
): err is SharedSpaceConsentGateError =>
  err instanceof SharedSpaceConsentGateError;

export const hasCommunicationOptIn = (consent: Consent): boolean =>
  consent.permissionStatusEmail === "Opt-in" ||
  consent.permissionStatusMobileMessages === "Opt-in";
